import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import './libraries/filters'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$OPEN_DATA_API = process.env.VUE_APP_OPEN_DATA_API;
Vue.prototype.$OPEN_DATA_METADATA = process.env.VUE_APP_OPEN_DATA_METADATA;

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_API_KEY,
		libraries: 'places', // This is required if you use the Autocomplete plugin
		region: 'CA'
	},
})

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
